module.exports = __webpack_public_path__ + "static/media/PB-RACE-BLUE-SQ-1.d751b56e.svg";